function AppFooterCopyright() {
  return (
    <div className="font-general-regular flex justify-center items-center text-center">
      <div className="text-lg text-ternary-dark dark:text-ternary-light">
        Designed &amp; Developed by
        <a
          href="https://github.com/prajwalborkar"
          target="__blank"
          className="text-secondary-dark dark:text-secondary-light font-medium uppercase hover:underline hover:text-indigo-600 dark:hover:text-indigo-300 ml-1 duration-500"
        >
          PRAJWAL BORKAR &copy; {new Date().getFullYear()}
        </a>
      </div>
    </div>
  );
}

export default AppFooterCopyright;
